"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useState, type MouseEvent, type PointerEvent, type TouchEvent } from "react";
type StopEvent = MouseEvent<HTMLElement> | PointerEvent<HTMLElement> | TouchEvent<HTMLElement>;
const stopPropagation = (event: StopEvent) => {
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation?.();
};
export default function ChatItemHrefButtons(t0) {
  const $ = _c(15);
  const {
    href,
    relativeHref,
    hideLink: t1
  } = t0;
  const hideLink = t1 === undefined ? false : t1;
  const [copied, setCopied] = useState(false);
  let t2;
  if ($[0] !== href) {
    t2 = event => {
      stopPropagation(event);
      navigator.clipboard.writeText(href).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 500);
      });
    };
    $[0] = href;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const copyToClipboard = t2;
  const t3 = copied ? "#27ae60" : "currentColor";
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <svg className="tw-flex-shrink-0 tw-w-4 tw-h-4 tw-transition tw-ease-out tw-duration-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke={t3}>{t4}</svg>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== copyToClipboard || $[6] !== t5) {
    t6 = <button type="button" className="tw-border-0 tw-flex tw-items-center tw-gap-x-2 tw-p-2 tw-bg-iron-900 tw-rounded-xl hover:tw-text-iron-400" onClick={copyToClipboard} onPointerDown={stopPropagation} onMouseDown={stopPropagation} onTouchStart={stopPropagation}>{t5}</button>;
    $[5] = copyToClipboard;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== hideLink || $[9] !== href || $[10] !== relativeHref) {
    t7 = !hideLink && <Link href={relativeHref ?? href} target={relativeHref ? undefined : "_blank"} className="tw-border-0 tw-flex tw-items-center tw-gap-x-2 tw-p-2 tw-bg-iron-900 tw-rounded-xl" onClick={stopPropagation} onPointerDown={stopPropagation} onMouseDown={stopPropagation} onTouchStart={stopPropagation}><svg className="tw-flex-shrink-0 tw-w-4 tw-h-4 tw-transition tw-ease-out tw-duration-300" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" strokeWidth="3" stroke="currentColor" fill="none"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M55.4,32V53.58a1.81,1.81,0,0,1-1.82,1.82H10.42A1.81,1.81,0,0,1,8.6,53.58V10.42A1.81,1.81,0,0,1,10.42,8.6H32" /><polyline points="40.32 8.6 55.4 8.6 55.4 24.18" /><line x1="19.32" y1="45.72" x2="54.61" y2="8.91" /></g></svg></Link>;
    $[8] = hideLink;
    $[9] = href;
    $[10] = relativeHref;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="tw-mt-1 tw-h-full tw-flex tw-flex-col tw-gap-y-2 tw-justify-start">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}